import { routesForTracking } from 'constants/routesForTracking';

export const calcAdditionalPageViewProperties = ({ pageName, queryParams }) => {
  if (
    [
      routesForTracking.reviewsCohortExplorePage.pageName,
      routesForTracking.reviewsCohortInsightsPage.pageName,
    ].includes(pageName)
  ) {
    return {};
  }
  return {};
};

export const cohortBasedPageViewCheck = ({ route, parsedCohortQueryParams = {} }) => {
  parsedCohortQueryParams = parsedCohortQueryParams ?? {};
  if (
    [
      routesForTracking.reviewsCohortExplorePage.pageName,
      routesForTracking.reviewsCohortInsightsPage.pageName,
    ].includes(route?.pageName)
  ) {
    const { id = null, type = null, name = '' } = parsedCohortQueryParams;
    if ([-1, -2, -3].includes(id) && name) {
      return { ...route, pageName: name };
    }
  }

  return route;
};
